import facebookIcon from "@assets/social/FacebookNew.svg";
import newPostIcon from "@assets/social/NewspostNew.svg";
import telegramIcon from "@assets/social/TelegramNew.svg";
import whatsappIconOnly from "@assets/social/whatsAppBlue.svg";
import whatsappIcon from "@assets/social/whatsAppNew.svg";
import LinkIcon from "@elements/LinkIcon/LinkIcon";
import { removeLeadingSlash } from "@helper/removeTrailingLeadingSlash";
import { getWindowOrigin } from "@helper/utils";

import { SocialVariant } from "./ShareSocial";

export type ShareSocialNewProps = {
  variant: SocialVariant;
  pageTitle?: string;
  pagePath: string;
  width?: string;
  dateCreated?: string;
  isAbsolutePagePath?: boolean;
};

export default function ShareSocialNew({
  variant,
  pageTitle,
  pagePath,
  dateCreated,
  width = "48px",
  isAbsolutePagePath = false,
}: ShareSocialNewProps) {
  const origin = getWindowOrigin();
  const shareTitle = pageTitle && encodeURIComponent(pageTitle);
  const sharePath = isAbsolutePagePath
    ? encodeURIComponent(pagePath)
    : encodeURIComponent(`${origin}/${removeLeadingSlash(pagePath)}`);
  const teleDestination = shareTitle
    ? `${sharePath}&text=${shareTitle}`
    : sharePath;
  const whatsappDestination = shareTitle
    ? `${shareTitle}%0A${sharePath}`
    : sharePath;
  const newsPostDestination = shareTitle;
  switch (variant) {
    case "facebook":
      return (
        <LinkIcon
          destination={`https://www.facebook.com/sharer/sharer.php?u=${sharePath}`}
          src={facebookIcon}
          alt="Share on Facebook"
          width={width}
        />
      );
    case "telegram":
      return (
        <LinkIcon
          destination={`https://t.me/share/url?url=${teleDestination}`}
          src={telegramIcon}
          alt="Share on Telegram"
          width={width}
        />
      );
    case "whatsapp":
    case "plainWhatsapp":
      return (
        <>
          <LinkIcon
            destination={`https://wa.me/?text=${whatsappDestination}`}
            src={whatsappIcon}
            alt="Share on WhatsApp"
            width="102px"
            wrapperClass="hidden lg:inline ml-2"
          />
          <LinkIcon
            destination={`https://wa.me/?text=${whatsappDestination}`}
            src={whatsappIconOnly}
            alt="Share on WhatsApp"
            width="37px"
            height="38px"
            wrapperClass="lg:hidden w-[48px] h-[48px] p-[5px]"
          />
        </>
      );
    case "newsPost":
      return (
        <LinkIcon
          destination={`https://newspost.newslink.sg/?publication=BH&date=${dateCreated}&title=${newsPostDestination}`}
          src={newPostIcon}
          alt="Purchase this article"
          width="165px"
          wrapperClass="ml-2"
        />
      );
    default:
      return null;
  }
}
